// extracted by mini-css-extract-plugin
module.exports = {"hero-overlay-multi-author":"hero-overlay-multi-author-m__hero-overlay-multi-author__2jC3C"};